export const ORDER_CATEGORY = [
  {
    label: '送餐',
    description: '可計入核銷報表',
  },
  {
    label: '送餐和物資',
    description: '可計入核銷報表',
  },
  {
    label: '送物資',
  },
  {
    label: '藝術',
  },
  {
    label: '醫療',
  },
  {
    label: '到府服務',
  },
  {
    label: '愛心餐',
    description: '弱勢長輩的愛心餐，不計入核銷報表，收據顯示0元',
  },
  {
    label: '自費餐',
    description: '弱勢長輩的自費餐，不計入核銷報表，列入弱勢長輩收據',
  },
];
export const ORDER_CATEGORY_LABEL = ORDER_CATEGORY.map(({ label }) => label);
